/**
 * Domain Loading Screen Component
 * Full-screen loading component shown while checking domain routing
 * Displays a centered spinner with "Loading..." text
 */

import { Loader2 } from 'lucide-react'

export function DomainLoadingScreen() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}
